import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function StarFilled({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M14.9146 7.98849L13.2688 2.92324C12.8694 1.69399 11.1306 1.69443 10.7314 2.92324L9.08556 7.98849H3.75963C2.46712 7.98849 1.93024 9.64228 2.97552 10.4017L7.28429 13.5322L5.63849 18.5975C5.23908 19.8267 6.64602 20.8484 7.6913 20.0889L12.0001 16.9584L16.3088 20.0889C17.3545 20.8487 18.7609 19.8263 18.3616 18.5975L16.7158 13.5322L21.0246 10.4017C22.0703 9.642 21.5326 7.98849 20.2405 7.98849H14.9146Z"
        fill={iconColor}
      />
    </Svg>
  );
}
